import { Avatar, Box, Container, Grid2 as Grid, Icon, Paper, Stack, Typography } from "@mui/material"
import { slickSettings } from "../../../../../utils/helper"
import Images from "../../../../../assets/js/Images"
import Icons from "../../../../../assets/js/Icons"
import Slider from "react-slick"
import { useRef } from "react"

function Testimonials() {
  const setting = {
    ...slickSettings,
    speed: 3000,
    autoplay: true,
    slidesToShow: 2,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  }
  const slickRef = useRef(null)

  return (
    <Box
      component="section"
      sx={{ pb: { xs: 5, lg: 10 }, pt:6 }}
    >
      <Box
        sx={{
          mx: "auto",
          display: "flex",
          maxWidth: "900px",
          textAlign: "center",
          alignItems: "center",
          gap: { xs: 1, lg: 3 },
          flexDirection: "column",
        }}
      >
        <Typography
          component="h6"
          color="#7a8a9e"
          variant="sectionLead"
        >Testimomonial
        </Typography>
        <Typography
          color="other.color1"
          variant="displayLarge"
        >What Our Customers Says 
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundSize: "cover",
          backgroundImage: `url(${Images?.specialist})`
        }}
      >
        <Container maxWidth={false} fixed sx={{ py: 4 }}>
          <Slider {...setting} ref={slickRef}>
            {new Array(3).fill()?.map((_, i) => (
              <Box key={i}>
                <Box sx={{ px: 3, py: 1 }}>
                  <Paper sx={{ p: "20px" }}>
                    <Box
                      sx={{
                        gap: 2,
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <Avatar
                        sx={{
                          width: { xs: "45px", lg: "60px" },
                          height: { xs: "45px", lg: "60px" },
                        }}
                      />
                      <Box>
                        <Typography
                          sx={{
                            lineHeight: "1",
                            fontWeight: "700",
                            color: "other.color1",
                            fontSize: { xs: "18px", lg: "20px" },
                          }}
                        >James Dokidis
                        </Typography>
                        <Typography
                          sx={{
                            color: "#6c757d",
                            fontWeight: "500"
                          }}
                        >Our customer
                        </Typography>
                      </Box>
                    </Box>
                    <Grid container spacing={2} mt="10px">
                      <Grid size="auto" order={{ xs: 2, md: 1, lg: 2, xl: 1 }}>
                        <Icon sx={{ fontSize: "60px", color: "secondary.main" }}>
                          <Icons.Quote1 />
                        </Icon>
                      </Grid>
                      <Grid size="grow" order={{ xs: 1, md: 2, lg: 1, xl: 2 }}>
                        <Typography
                          sx={{
                            p: "10px",
                            opacity: "0.6",
                            color: "#7A8A9E",
                            fontWeight: "400",
                            lineHeight: "28px",
                            transform: "scale(0.9)",
                            transition: "all 1000ms ease",
                            ":hover": {
                              opacity: "1",
                              color: "#223645",
                              transform: "scale(1.02)"
                            }
                          }}
                        >Lorem, ipsum dolor sit amet consectetur adipisicing elit. Consequuntur incidunt, dolores ea voluptas pariatur doloribus mollitia architecto necessitatibus quasi fuga? Id eius aut excepturi. A est aut eligendi et perferendis eveniet, quasi dicta consequatur aperiam similique non, veritatis officiis quo.
                        </Typography>
                        <Stack
                          mt={2}
                          spacing={1}
                          direction="row"
                        >
                          {new Array(5).fill().map((_, i) => (
                            <Icon
                              key={i}
                              sx={{
                                color: i < 4 ? "#e5b216" : "#d6d6d6"
                              }}
                            >
                              <Icons.Star />
                            </Icon>
                          ))
                          }
                        </Stack>
                      </Grid>
                    </Grid>
                  </Paper>
                </Box>
              </Box>
            ))
            }
          </Slider>
        </Container>
      </Box>
    </Box>
  )
}

export default Testimonials